import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { api } from '../config/api';
import signatureImg from '../assets/signature.jpg';
import { 
  masterPanel, 
  masterFormContainer,
  masterFormGrid3,
  masterFormGridRow,
  masterInputLabel,
  masterAccentButton, 
  masterPrimaryButton,
  masterInput,
  masterSectionTitle,
  masterFormActions,
  masterStickyHeadRow,
  masterTableHeaderCell,
  masterTableHeaderCellCenter,
  masterTable,
  masterTableWrap,
  masterTableRow,
  masterTableData,
  masterTableActionCell,
  masterEditButton,
  masterDeleteButton
} from './MasterCssClass';

const numberToWords = (num) => {
  if (!num || isNaN(num)) return 'ZERO ONLY';
  const a = ['', 'ONE ', 'TWO ', 'THREE ', 'FOUR ', 'FIVE ', 'SIX ', 'SEVEN ', 'EIGHT ', 'NINE ', 'TEN ', 'ELEVEN ', 'TWELVE ', 'THIRTEEN ', 'FOURTEEN ', 'FIFTEEN ', 'SIXTEEN ', 'SEVENTEEN ', 'EIGHTEEN ', 'NINETEEN '];
  const b = ['', '', 'TWENTY', 'THIRTY', 'FORTY', 'FIFTY', 'SIXTY', 'SEVENTY', 'EIGHTY', 'NINETY'];

  const n = ('000000000' + Math.floor(num)).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
  if (!n) return '';
  let str = '';
  str += (Number(n[1]) !== 0) ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'CRORE ' : '';
  str += (Number(n[2]) !== 0) ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'LAKH ' : '';
  str += (Number(n[3]) !== 0) ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'THOUSAND ' : '';
  str += (Number(n[4]) !== 0) ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'HUNDRED ' : '';
  str += (Number(n[5]) !== 0) ? ((str !== '') ? 'AND ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) : '';
  return (str.trim().toUpperCase() + ' ONLY');
};

const getTodayDate = () => {
  const d = new Date();
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${day}-${month}-${year}`;
};

const AKYBilling = ({ handleLogout, isAnandiUser }) => {
  const [invoices, setInvoices] = useState([]);
  const [showList, setShowList] = useState(false);
  const [editId, setEditId] = useState(null);
  const [printingInvoice, setPrintingInvoice] = useState(null);

  const [invoiceNumber, setInvoiceNumber] = useState('');
  const [invoiceDate, setInvoiceDate] = useState(getTodayDate());
  const [customerName, setCustomerName] = useState('');
  const [address, setAddress] = useState('');
  const [customerGstin, setCustomerGstin] = useState('');
  const [contact1, setContact1] = useState('');
  const [contact2, setContact2] = useState('');
  const [contact3, setContact3] = useState('');
  const [receivedAmount, setReceivedAmount] = useState('');

  const [items, setItems] = useState([
    { itemName: '', hsnSac: '', quantity: '', priceUnit: '', gstRate: '' }
  ]);

  const fetchInvoices = async () => {
    try {
      const res = await api.get('/aky-billing');
      setInvoices(res.data || []);
    } catch (err) {
      console.error(err);
      toast.error('FAILED TO LOAD AKY INVOICES');
    }
  };

  useEffect(() => {
    fetchInvoices();
  }, []);

  const handleDateChange = (e) => {
    let val = e.target.value.replace(/[^\d]/g, '');
    if (val.length > 8) val = val.slice(0, 8);
    if (val.length > 4) {
      val = `${val.slice(0, 2)}-${val.slice(2, 4)}-${val.slice(4)}`;
    } else if (val.length > 2) {
      val = `${val.slice(0, 2)}-${val.slice(2)}`;
    }
    setInvoiceDate(val);
  };

  const handleAddItem = () => {
    const firstHsn = items[0]?.hsnSac || '';
    const firstGst = items[0]?.gstRate || '';
    setItems([...items, { itemName: '', hsnSac: firstHsn, quantity: '', priceUnit: '', gstRate: firstGst }]);
  };

const handleItemChange = (index, field, value) => {
    setItems(prevItems => {
      const updated = [...prevItems];
      updated[index] = { ...updated[index], [field]: value };
      
      if (index === 0 && (field === 'hsnSac' || field === 'gstRate')) {
        for (let i = 1; i < updated.length; i++) {
          if (!updated[i][field] || updated[i][field] === prevItems[i][field]) {
            updated[i] = { ...updated[i], [field]: value };
          }
        }
      }
      return updated;
    });
  };

  const handleRemoveItem = (index) => {
    if (items.length === 1) return;
    setItems(items.filter((_, i) => i !== index));
  };

  const calculatedItems = items.map(item => {
    const qty = item.quantity === '' ? 0 : Number(item.quantity);
    const rate = item.priceUnit === '' ? 0 : Number(item.priceUnit);
    const gstPct = item.gstRate === '' ? 0 : Number(item.gstRate);
    
    const taxable = qty * rate;
    const gstAmt = (taxable * gstPct) / 100;
    const amount = taxable + gstAmt;

    return {
      ...item,
      qtyNumber: qty,
      rateNumber: rate,
      taxableAmount: taxable,
      gstAmount: gstAmt,
      amount: amount
    };
  });

  const totalQuantity = calculatedItems.reduce((acc, curr) => acc + curr.qtyNumber, 0);
  const totalTaxAmount = calculatedItems.reduce((acc, curr) => acc + curr.gstAmount, 0);
  const grandTotal = calculatedItems.reduce((acc, curr) => acc + curr.amount, 0);
  const recAmtNumber = receivedAmount === '' ? 0 : Number(receivedAmount);
  const balanceAmount = grandTotal - recAmtNumber;
  const amountInWords = numberToWords(grandTotal);

  const taxSummary = calculatedItems.reduce((acc, curr) => {
    const key = curr.hsnSac || 'GENERAL';
    const rateKey = curr.gstRate || 0;
    const groupKey = `${key}_${rateKey}`;
    
    if (!acc[groupKey]) {
      acc[groupKey] = { hsn: key, taxable: 0, totalTax: 0, gstRate: Number(rateKey) };
    }
    acc[groupKey].taxable += curr.taxableAmount;
    acc[groupKey].totalTax += curr.gstAmount;
    return acc;
  }, {});

  const resetForm = () => {
    setEditId(null);
    setInvoiceNumber('');
    setInvoiceDate(getTodayDate());
    setCustomerName('');
    setAddress('');
    setCustomerGstin('');
    setContact1('');
    setContact2('');
    setContact3('');
    setReceivedAmount('');
    setItems([{ itemName: '', hsnSac: '', quantity: '', priceUnit: '', gstRate: '' }]);
  };

const handleSaveInvoice = async (e, shouldPrint = false) => {
    e.preventDefault();

    if (!customerName.trim()) {
      toast.error('CUSTOMER / SHOP NAME IS REQUIRED');
      return;
    }
    if (!invoiceNumber.trim()) {
      toast.error('INVOICE NUMBER IS REQUIRED');
      return;
    }
    if (!contact1 || !/^\d{10}$/.test(contact1)) {
      toast.error('CONTACT 1 MUST BE A VALID 10-DIGIT NUMBER');
      return;
    }

    const payload = {
      invoiceNumber: invoiceNumber.toUpperCase(),
      invoiceDate,
      customerName: customerName.toUpperCase(),
      address: address.toUpperCase(),
      customerGstin: customerGstin.toUpperCase(),
      contact1,
      contact2,
      contact3,
      items: calculatedItems.map(i => ({
        itemName: i.itemName.toUpperCase(),
        hsnSac: i.hsnSac.toUpperCase(),
        quantity: i.qtyNumber,
        priceUnit: i.rateNumber,
        gstRate: Number(i.gstRate),
        gstAmount: i.gstAmount,
        taxableAmount: i.taxableAmount,
        amount: i.amount
      })),
      taxSummary: Object.values(taxSummary),
      totalQuantity,
      totalTaxAmount,
      subTotal: grandTotal,
      grandTotal,
      amountInWords,
      receivedAmount: recAmtNumber,
      balanceAmount,
      termsAndConditions: 'THANK YOU FOR DOING BUSINESS WITH US.'
    };

    try {
      let savedRes;
      if (editId) {
        const res = await api.put(`/aky-billing/${editId}`, payload);
        savedRes = res.data;
        toast.success('AKY INVOICE UPDATED SUCCESSFULLY!');
      } else {
        const res = await api.post('/aky-billing', payload);
        savedRes = res.data;
        toast.success('AKY INVOICE SAVED & BILL ID GENERATED!');
      }

      if (shouldPrint) {
        const tempInv = { 
          ...payload, 
          billId: editId ? (invoices.find(i => i._id === editId)?.billId || 'SAVED') : (savedRes?.billId || 'SAVED') 
        };
        resetForm();
        fetchInvoices();
        handlePrint(tempInv);
      } else {
        resetForm();
        fetchInvoices();
        setShowList(true);
      }
    } catch (err) {
      toast.error(err.response?.data?.error || err.message);
    }
  };

  const handleEdit = (inv) => {
    setEditId(inv._id);
    setInvoiceNumber(inv.invoiceNumber || '');
    setInvoiceDate(inv.invoiceDate || getTodayDate());
    setCustomerName(inv.customerName || '');
    setAddress(inv.address || '');
    setCustomerGstin(inv.customerGstin || '');
    setContact1(inv.contact1 || '');
    setContact2(inv.contact2 || '');
    setContact3(inv.contact3 || '');
    setReceivedAmount(inv.receivedAmount ? String(inv.receivedAmount) : '');
    setItems(inv.items && inv.items.length > 0 ? inv.items.map(i => ({
      itemName: i.itemName,
      hsnSac: i.hsnSac,
      quantity: String(i.quantity),
      priceUnit: String(i.priceUnit),
      gstRate: String(i.gstRate)
    })) : [{ itemName: '', hsnSac: '', quantity: '', priceUnit: '', gstRate: '' }]);
    setShowList(false);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('ARE YOU SURE YOU WANT TO DELETE THIS INVOICE?')) return;
    try {
      await api.delete(`/aky-billing/${id}`);
      toast.success('DELETED SUCCESSFULLY');
      fetchInvoices();
    } catch (err) {
      toast.error('FAILED TO DELETE INVOICE');
    }
  };

  const handlePrint = (inv) => {
    setPrintingInvoice(inv);
    setTimeout(() => {
      window.print();
    }, 150);
  };
const activePrint = printingInvoice || {
    billId: editId ? invoices.find(i => i._id === editId)?.billId : 'PENDING',
    invoiceNumber: invoiceNumber.toUpperCase(),
    invoiceDate,
    customerName: customerName.toUpperCase(),
    address: address.toUpperCase(),
    customerGstin: customerGstin.toUpperCase(),
    contact1,
    contact2,
    contact3,
    items: calculatedItems,
    taxSummary: printingInvoice?.taxSummary?.length > 0 ? printingInvoice.taxSummary : Object.values(taxSummary), // <--- ADD THIS LINE HERE
    totalQuantity,
    totalTaxAmount,
    subTotal: grandTotal,
    grandTotal,
    amountInWords,
    receivedAmount: recAmtNumber,
    balanceAmount
  };

  const printContacts = [activePrint.contact1, activePrint.contact2, activePrint.contact3].filter(Boolean).join('/');


 return (
    <div className="space-y-2">
      <div className="print:hidden flex justify-between items-center px-1">
        {/* Left side: Brand title if anandi */}
        <div>
          {isAnandiUser && (
            <span className="text-xs font-bold text-[#358156] uppercase">SANTU ENTERPRISES</span>
          )}
        </div>

        {/* Right side: Logout and View List together in the same row */}
        <div className="flex items-center gap-1">
          {isAnandiUser && (
            <button 
              type="button" 
              onClick={handleLogout} 
              className="px-3 py-1 bg-red-600 text-white rounded text-[10px] font-bold uppercase shadow hover:bg-red-700"
            >
              LOGOUT
            </button>
          )}
          <button 
            onClick={() => {
              if (showList) { resetForm(); setShowList(false); }
              else { setShowList(true); }
            }} 
            className={masterPrimaryButton}
          >
            {showList ? 'NEW BILL FORM' : `View list`}
          </button>
        </div>
      </div>

      {!showList ? (
        <div className={`print:hidden ${masterPanel}`}>
          <div className={masterFormContainer}>
            <h2 className={masterSectionTitle}>
              {editId ? 'EDIT AKY TAX INVOICE' : 'AKY TAX INVOICE GENERATOR'}
            </h2>

           <form onSubmit={handleSaveInvoice} className="space-y-2 uppercase">
              <div className={masterFormGrid3}>
                <div className={masterFormGridRow} style={{ gridColumn: 'span 2' }}>
                  <label className={masterInputLabel}>INVOICE NO *</label>
                  <input 
                    type="text" 
                    value={invoiceNumber} 
                    onChange={e => setInvoiceNumber(e.target.value)} 
                    placeholder="E.G. 72/2026" 
                    className={masterInput} 
                    style={{ textTransform: 'uppercase' }}
                    required 
                  />
                </div>
                <div className={masterFormGridRow}>
                  <label className={masterInputLabel}>INVOICE DATE (DD-MM-YYYY) *</label>
                  <input 
                    type="text" 
                    value={invoiceDate} 
                    onChange={handleDateChange} 
                    placeholder="DD-MM-YYYY" 
                    className={masterInput} 
                    required 
                  />
                </div>
              </div>

              <div className={masterFormGrid3}>
                <div className={masterFormGridRow}>
                  <label className={masterInputLabel}>CUSTOMER / SHOP NAME *</label>
                  <input 
                    type="text" 
                    value={customerName} 
                    onChange={e => setCustomerName(e.target.value)} 
                    placeholder="E.G. MOHINI THE FAMILY SHOP" 
                    className={masterInput} 
                    style={{ textTransform: 'uppercase' }}
                    required 
                  />
                </div>
                <div className={masterFormGridRow}>
                  <label className={masterInputLabel}>CUSTOMER ADDRESS</label>
                  <input 
                    type="text" 
                    value={address} 
                    onChange={e => setAddress(e.target.value)} 
                    placeholder="E.G. KHAJPURA, PATNA - 4" 
                    className={masterInput} 
                    style={{ textTransform: 'uppercase' }}
                  />
                </div>
                <div className={masterFormGridRow}>
                  <label className={masterInputLabel}>CUSTOMER GSTIN</label>
                  <input 
                    type="text" 
                    value={customerGstin} 
                    onChange={e => setCustomerGstin(e.target.value)} 
                    placeholder="E.G. 10AJEPG6668F2ZG" 
                    className={masterInput} 
                    style={{ textTransform: 'uppercase' }}
                  />
                </div>
              </div>

              <div className={masterFormGrid3}>
                <div className={masterFormGridRow}>
                  <label className={masterInputLabel}>CONTACT NO 1 (10-DIGIT) *</label>
                  <input 
                    type="text" 
                    maxLength="10" 
                    value={contact1} 
                    onChange={e => setContact1(e.target.value.replace(/\D/g, ''))} 
                    placeholder="REQUIRED" 
                    className={masterInput} 
                    required 
                  />
                </div>
                <div className={masterFormGridRow}>
                  <label className={masterInputLabel}>CONTACT NO 2</label>
                  <input 
                    type="text" 
                    maxLength="10" 
                    value={contact2} 
                    onChange={e => setContact2(e.target.value.replace(/\D/g, ''))} 
                    placeholder="10 DIGITS" 
                    className={masterInput} 
                  />
                </div>
                <div className={masterFormGridRow}>
                  <label className={masterInputLabel}>CONTACT NO 3</label>
                  <input 
                    type="text" 
                    maxLength="10" 
                    value={contact3} 
                    onChange={e => setContact3(e.target.value.replace(/\D/g, ''))} 
                    placeholder="10 DIGITS" 
                    className={masterInput} 
                  />
                </div>
              </div>

              <div className="border border-[#358156]/20 p-2 rounded-lg space-y-2 bg-slate-50">
                <div className="flex justify-between items-center">
                  <span className={masterInputLabel}>ITEMS LIST (AUTO-CALCULATED AMOUNT + GST)</span>
                  <button 
                    type="button" 
                    onClick={handleAddItem} 
                    className="px-2 py-0.5 bg-[#358156] text-white rounded text-[10px] font-bold uppercase"
                  >
                    + ADD ITEM
                  </button>
                </div>

                {/* Column Headers for Form Rows */}
                <div className="hidden sm:grid grid-cols-12 gap-1 px-1 text-[9px] font-bold text-slate-600 uppercase border-b border-slate-300 pb-1">
                  <div className="col-span-4">ITEM NAME</div>
                  <div className="col-span-2">HSN/SAC</div>
                  <div className="col-span-1">QTY</div>
                  <div className="col-span-2">PRICE/UNIT</div>
                  <div className="col-span-2">GST RATE %</div>
                  <div className="col-span-1 text-center">ACT</div>
                </div>

                {items.map((item, idx) => (
                  <div key={`item-${idx}`} className="grid grid-cols-1 sm:grid-cols-12 gap-1 items-center border-b border-slate-200 pb-2">
                    <div className="sm:col-span-4">
                      <input 
                        type="text" 
                        placeholder="ITEM NAME" 
                        value={item.itemName} 
                        onChange={e => handleItemChange(idx, 'itemName', e.target.value)} 
                        className={masterInput} 
                        style={{ textTransform: 'uppercase' }}
                        required 
                      />
                    </div>
                    <div className="sm:col-span-2">
                      <input 
                        type="text" 
                        placeholder="HSN/SAC" 
                        value={item.hsnSac} 
                        onChange={e => handleItemChange(idx, 'hsnSac', e.target.value)} 
                        className={masterInput} 
                        style={{ textTransform: 'uppercase' }}
                        required 
                      />
                    </div>
                    <div className="sm:col-span-1">
                      <input 
                        type="number" 
                        placeholder="QTY" 
                        value={item.quantity} 
                        onChange={e => handleItemChange(idx, 'quantity', e.target.value)} 
                        className={masterInput} 
                        required 
                      />
                    </div>
                    <div className="sm:col-span-2">
                      <input 
                        type="number" 
                        placeholder="PRICE/UNIT" 
                        value={item.priceUnit} 
                        onChange={e => handleItemChange(idx, 'priceUnit', e.target.value)} 
                        className={masterInput} 
                        required 
                      />
                    </div>
                    <div className="sm:col-span-2">
                      <input 
                        type="number" 
                        placeholder="GST RATE %" 
                        value={item.gstRate} 
                        onChange={e => handleItemChange(idx, 'gstRate', e.target.value)} 
                        className={masterInput} 
                        required 
                      />
                    </div>
                    <div className="sm:col-span-1 flex justify-center">
                      {items.length > 1 && (
                        <button 
                          type="button" 
                          onClick={() => handleRemoveItem(idx)} 
                          className="px-2 py-1 bg-red-500 text-white rounded text-[10px] font-bold"
                        >
                          X
                        </button>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              {/* Received Amount at the Bottom Last */}
              <div className={masterFormGrid3}>
                <div className={masterFormGridRow}>
                  <label className={masterInputLabel}>RECEIVED AMOUNT</label>
                  <input 
                    type="number" 
                    value={receivedAmount} 
                    onChange={e => setReceivedAmount(e.target.value)} 
                    placeholder="0.00" 
                    className={masterInput} 
                  />
                </div>
                <div className={masterFormGridRow} style={{ gridColumn: 'span 2' }}>
                  <div className="p-2 bg-slate-100 rounded border border-slate-300 text-xs font-bold flex justify-between items-center text-slate-800 h-full">
                    <span>TOTAL QTY: <span className="text-[#358156]">{totalQuantity}</span></span>
                    <span>GRAND TOTAL: <span className="text-[#358156]">RS {grandTotal.toFixed(2)}</span></span>
                    <span>BALANCE: <span className="text-red-600">RS {balanceAmount.toFixed(2)}</span></span>
                  </div>
                </div>
              </div>

           <div className="flex flex-wrap gap-1 justify-between items-center pt-2 border-t border-slate-200 mt-2">
                {editId && (
                  <button type="button" onClick={resetForm} className="px-2 py-1 bg-slate-500 text-white rounded text-[10px] font-bold uppercase">
                    CANCEL
                  </button>
                )}
                <div className="flex gap-1 w-full sm:w-auto justify-end ml-auto">
                  <button 
                    type="submit" 
                    onClick={(e) => handleSaveInvoice(e, false)}
                    className="flex-1 sm:flex-none px-3 py-1.5 bg-slate-700 text-white rounded text-[10px] font-bold uppercase"
                  >
                    {editId ? 'UPDATE ONLY' : 'SAVE ONLY'}
                  </button>
                  <button 
                    type="submit" 
                    onClick={(e) => handleSaveInvoice(e, true)}
                    className={`flex-1 sm:flex-none ${masterAccentButton}`}
                  >
                    SAVE & DOWNLOAD PDF
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      ) : (
        <div className={`print:hidden ${masterPanel}`}>
          <div className={masterTableWrap}>
            <table className={masterTable}>
              <thead>
                <tr className={masterStickyHeadRow}>
                  <th className={masterTableHeaderCell}>BILL ID</th>
                  <th className={masterTableHeaderCell}>INVOICE NO</th>
                  <th className={masterTableHeaderCell}>DATE</th>
                  <th className={masterTableHeaderCell}>CUSTOMER NAME</th>
                  <th className={masterTableHeaderCell}>GRAND TOTAL (RS)</th>
                  <th className={masterTableHeaderCell}>BALANCE (RS)</th>
                  <th className={masterTableHeaderCellCenter}>ACTION</th>
                </tr>
              </thead>
              <tbody>
                {invoices.map(inv => (
                  <tr key={inv._id} className={masterTableRow}>
                    <td className={masterTableData}><span className="font-bold text-[#358156]">{inv.billId}</span></td>
                    <td className={masterTableData}>{inv.invoiceNumber}</td>
                    <td className={masterTableData}>{inv.invoiceDate}</td>
                    <td className={masterTableData}>{inv.customerName}</td>
                    <td className={masterTableData}>{inv.grandTotal?.toFixed(2)}</td>
                    <td className={masterTableData}>{inv.balanceAmount?.toFixed(2)}</td>
                    <td className={masterTableActionCell}>
                      <div className="flex justify-center gap-1">
                        <button onClick={() => handleEdit(inv)} className={masterEditButton}>
                          EDIT
                        </button>
                        <button onClick={() => handlePrint(inv)} className="px-2 py-0.5 bg-[#358156] text-white rounded text-[10px] font-bold uppercase">
                          PDF
                        </button>
                        <button onClick={() => handleDelete(inv._id)} className={masterDeleteButton}>
                          DELETE
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
                {invoices.length === 0 && (
                  <tr>
                    <td colSpan="7" className="text-center p-4 text-xs text-slate-500">NO SAVED INVOICES FOUND.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* =========================================================================
          PICTURE-PERFECT PRINTABLE INVOICE TEMPLATE
         ========================================================================= */}
      <div className="hidden print:block font-sans text-[10px] text-black bg-white p-2 leading-tight uppercase">
        <div className="text-center mb-1">
          <h2 className="font-bold text-xs tracking-wider underline">TAX INVOICE</h2>
        </div>

        <div className="border border-black">
      {/* Header */}
          <div className="p-2 border-b border-black flex justify-between items-end">
            <div>
              <h1 className="font-bold text-sm tracking-wide">SANTU ENTERPRISES</h1>
              <div className="text-[9px] mt-0.5 space-y-0.5 font-semibold">
                <div className="grid grid-cols-[55px_10px_1fr]">
                  <span className="font-bold">PHONE</span><span>:</span><span>9051341025 / 7890563801</span>
                </div>
                <div className="grid grid-cols-[55px_10px_1fr]">
                  <span className="font-bold">GSTIN</span><span>:</span><span>10HWAPK2447C1Z5</span>
                </div>
              </div>
            </div>
            <div className="text-[9px] space-y-0.5 font-semibold flex flex-col items-end">
              <div className="grid grid-cols-[45px_10px_175px]">
                <span className="font-bold text-left">EMAIL</span><span>:</span><span className="normal-case text-left">shakticons63801@gmail.com</span>
              </div>
              <div className="grid grid-cols-[45px_10px_175px]">
                <span className="font-bold text-left">STATE</span><span>:</span><span className="text-left">10 BIHAR</span>
              </div>
            </div>
          </div>

          {/* Bill To & Invoice Info (Bill ID removed, TO: prefix added) */}
          <div className="grid grid-cols-2 border-b border-black text-[9px]">
            <div className="p-2 border-r border-black space-y-0.5">
              <p className="font-bold underline mb-1">BILL TO:</p>
              <p className="font-bold text-[10px]">TO: {activePrint.customerName || 'N/A'}</p>
              {activePrint.address && (
                <div className="grid grid-cols-[50px_10px_1fr] font-semibold">
                  <span>Address</span><span>:</span><span>{activePrint.address}</span>
                </div>
              )}
              {activePrint.customerGstin && (
                <div className="grid grid-cols-[50px_10px_1fr] font-semibold">
                  <span>GSTIN</span><span>:</span><span>{activePrint.customerGstin}</span>
                </div>
              )}
              <div className="grid grid-cols-[50px_10px_1fr] font-semibold">
                <span>Contact</span><span>:</span><span>{printContacts || 'N/A'}</span>
              </div>
            </div>
            <div className="p-2 space-y-0.5">
              <p className="font-bold underline mb-1">INVOICE DETAILS:</p>
              <div className="grid grid-cols-[65px_10px_1fr] font-semibold">
                <span>Invoice No</span><span>:</span><span>{activePrint.invoiceNumber || 'N/A'}</span>
              </div>
              <div className="grid grid-cols-[65px_10px_1fr] font-semibold">
                <span>Date</span><span>:</span><span>{activePrint.invoiceDate || 'N/A'}</span>
              </div>
            </div>
          </div>

   {/* Items Table */}
          <table className="w-full border-collapse text-[9px] text-center border-b border-black">
            <thead>
              <tr className="border-b border-black font-bold bg-gray-100">
                <th className="border-r border-black p-1 w-8">SL NO</th>
                <th className="border-r border-black p-1 text-left px-2">ITEM NAME</th>
                <th className="border-r border-black p-1 w-14">HSN/SAC</th>
                <th className="border-r border-black p-1 w-12">QTY</th>
                <th className="border-r border-black p-1 w-16">PRICE/UNIT</th>
                <th className="border-r border-black p-1 w-14">GST RATE</th>
                <th className="border-r border-black p-1 w-16">GST AMT</th>
                <th className="p-1 w-20">AMOUNT</th>
              </tr>
            </thead>
            <tbody>
              {activePrint.items?.map((item, idx) => (
                <tr key={idx} className="border-b border-black/40">
                  <td className="border-r border-black p-1 font-semibold">{idx + 1}</td>
                  <td className="border-r border-black p-1 text-left px-2 font-semibold">{item.itemName || '-'}</td>
                  <td className="border-r border-black p-1 font-semibold">{item.hsnSac || '-'}</td>
                  <td className="border-r border-black p-1 font-semibold">{item.quantity || item.qtyNumber || 0}</td>
                  <td className="border-r border-black p-1 font-semibold">{item.priceUnit || item.rateNumber || 0}</td>
                  <td className="border-r border-black p-1 font-semibold">{item.gstRate || 0}%</td> 
                  <td className="border-r border-black p-1 font-semibold">{Number(item.gstAmount || 0).toFixed(2)}</td>
                  <td className="p-1 text-right pr-2 font-semibold">{Number(item.amount || 0).toFixed(2)}</td>
                </tr>
              ))}
              <tr className="border-t border-black font-bold">
                <td colSpan="3" className="border-r border-black p-1 text-center">TOTAL</td>
                <td className="border-r border-black p-1">{activePrint.totalQuantity}</td>
                <td className="border-r border-black p-1"></td>
                <td className="border-r border-black p-1"></td>
                <td className="border-r border-black p-1">{Number(activePrint.totalTaxAmount).toFixed(2)}</td>
                <td className="p-1 text-right pr-2">RS {Number(activePrint.grandTotal).toFixed(2)}</td>
              </tr>
            </tbody>
          </table>

          {/* Tax Summary & Bottom Totals */}
          <div className="grid grid-cols-[1.3fr_1fr] border-b border-black">
            <div className="border-r border-black p-1">
              <p className="font-bold text-[8px] mb-1 underline">TAX SUMMARY</p>
              <table className="w-full border-collapse border border-black text-[8px] text-center">
                <thead>
                  <tr className="border-b border-black font-bold bg-gray-50">
                    <th rowSpan="2" className="border-r border-black p-0.5">HSN/SAC</th>
                    <th rowSpan="2" className="border-r border-black p-0.5">TAXABLE AMT</th>
                    <th colSpan="2" className="border-r border-black p-0.5">CGST</th>
                    <th colSpan="2" className="border-r border-black p-0.5">SGST</th>
                    <th rowSpan="2" className="p-0.5">TOTAL TAX</th>
                  </tr>
                  <tr className="border-b border-black font-bold text-[7px] bg-gray-50">
                    <th className="border-r border-black p-0.5">RATE</th>
                    <th className="border-r border-black p-0.5">AMT</th>
                    <th className="border-r border-black p-0.5">RATE</th>
                    <th className="border-r border-black p-0.5">AMT</th>
                  </tr>
                </thead>
                <tbody>
                  {(activePrint.taxSummary && activePrint.taxSummary.length > 0 ? activePrint.taxSummary : Object.values(taxSummary)).map((ts, i) => (
                    <tr key={i} className="border-b border-black/40 font-semibold">
                      <td className="border-r border-black p-0.5">{ts.hsn}</td>
                      <td className="border-r border-black p-0.5">{Number(ts.taxable).toFixed(2)}</td>
                      <td className="border-r border-black p-0.5">{(Number(ts.gstRate) / 2).toFixed(1)}%</td>
                      <td className="border-r border-black p-0.5">{Number(ts.totalTax / 2).toFixed(2)}</td>
                      <td className="border-r border-black p-0.5">{(Number(ts.gstRate) / 2).toFixed(1)}%</td>
                      <td className="border-r border-black p-0.5">{Number(ts.totalTax / 2).toFixed(2)}</td>
                      <td className="p-0.5">{Number(ts.totalTax).toFixed(2)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="p-1.5 text-[9px] space-y-1 font-semibold flex flex-col justify-between">
              <div className="space-y-0.5">
                <div className="grid grid-cols-[65px_10px_1fr] border-b border-black/20 pb-0.5">
                  <span className="font-bold">SUB TOTAL</span><span>:</span><span>RS {Number(activePrint.subTotal).toFixed(2)}</span>
                </div>
                <div className="grid grid-cols-[65px_10px_1fr] border-b border-black/20 pb-0.5">
                  <span className="font-bold">TOTAL</span><span>:</span><span>RS {Number(activePrint.grandTotal).toFixed(2)}</span>
                </div>
                <div className="border-b border-black/20 pb-0.5">
                  <p className="font-bold text-[8px]">AMOUNT IN WORDS:</p>
                  <p className="text-[8px] italic font-bold leading-tight">{activePrint.amountInWords}</p>
                </div>
              </div>
              <div className="space-y-0.5 pt-0.5">
                <div className="grid grid-cols-[65px_10px_1fr]">
                  <span className="font-bold">RECEIVED</span><span>:</span><span>RS {Number(activePrint.receivedAmount).toFixed(2)}</span>
                </div>
                <div className="grid grid-cols-[65px_10px_1fr] border-t border-black pt-0.5">
                  <span className="font-bold">BALANCE</span><span>:</span><span className="font-bold">RS {Number(activePrint.balanceAmount).toFixed(2)}</span>
                </div>
              </div>
            </div>
          </div>

          {/* Terms */}
          <div className="p-1 border-b border-black text-[8px]">
            <p className="font-bold underline">TERMS AND CONDITIONS:</p>
            <p className="font-bold">THANK YOU FOR DOING BUSINESS WITH US.</p>
          </div>

          {/* Bank Details & Signature */}
          <div className="grid grid-cols-[1.3fr_1fr] p-1.5 text-[9px]">
            <div className="space-y-0.5 font-semibold text-[8px]">
              <p className="font-bold underline text-[9px] mb-0.5">BANK DETAILS</p>
              <div className="grid grid-cols-[70px_10px_1fr]"><span>NAME</span><span>:</span><span>PUNJAB NATIONAL BANK</span></div>
              <div className="grid grid-cols-[70px_10px_1fr]"><span>ACCOUNT NO</span><span>:</span><span>1441002100003136</span></div>
              <div className="grid grid-cols-[70px_10px_1fr]"><span>IFSC CODE</span><span>:</span><span>PUNB0144100</span></div>
              <div className="grid grid-cols-[70px_10px_1fr]"><span>HOLDER’S NAME</span><span>:</span><span>SANTU ENTERPRISES</span></div>
            </div>
            <div className="flex flex-col items-center justify-between">
              <p className="font-bold text-[9px]">FOR SANTU ENTERPRISES</p>
              <img src={signatureImg} alt="Signature" className="h-8 object-contain my-0.5" />
              <p className="font-bold text-[8px] tracking-wider border-t border-black pt-0.5 w-full text-center">AUTHORIZED SIGNATORY</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AKYBilling;